const inquiryQuotationTermsCondition = `
<p>1. Delivery Period: Ex our factory within 15 days after your confirmed order.</p>
<p>&nbsp;</p>
<p>2. Payment terms: 30% Advance & 70% balance against proforma Invoice.</p>
<p>&nbsp;</p>
<p>3. 18% GST as applicable on the above price</p>
<p>&nbsp;</p>
<p>4. Packing charges: Will be extra Rs. 1.50/- per kg. On the above prices. The packing mode will be HDPE which please noted.</p>
<p>&nbsp;</p>
<p>5. Transportation would be extra as actual on to pay basis.</p>
<p>&nbsp;</p>
<p>6. Insurance: Will be extra, if applicable.</p>
<p>&nbsp;</p>
<p>7. Cut Length Tolerance: Shall be +/- 10mm.</p>
<p>&nbsp;</p>
<p>8. Finish Of Material & Shipping Tolerance: Material will Supply in mill finish condition & Shipping tolerance will be +/- 10% by order
weight. Wt. kgs/meter mentioned on drawing is for reference purpose, it may varies due to tolerances.</p>
<p>&nbsp;</p>
<p>9. Guarantee: All Chemical & Mechanical properties shall be as per Indian standard & tolerances on any dimension will be as per
our section drawing only..</p>
<p>&nbsp;</p>
<p>10. Penalty Clause: Not Acceptable.</p>
<p>&nbsp;</p>
<p>11. The above prices are present Prices. We will consider the fluctuations prevailing as per the Nalco Ingot price (IE07) at the time
of dispatch which please note. The Current Price of Nalco Ingot is Rs.277.95 dated 01st Oct 2025.</p>
<p>&nbsp;</p>
`;

export default inquiryQuotationTermsCondition;
